module.exports = __webpack_public_path__ + "img/I-10883_12-a.b4817a0a.jpg";